import { selectEmail, selectUserConfigData } from 'root-redux/selects/user'

import { getPurchaseCommonEventParams } from 'modules/purchase/helpers/getPurchaseCommonEventParams'

import { IAppState } from 'models/store.model'

import { CookieConsentOption } from 'root-constants'

export const getPurchaseSuccessEventParams = (state: IAppState) => {
  const {
    trialPeriodPrice,
    uuid,
    periodName,
    periodQuantity,
    currency,
    screenName,
    stripeAccountName,
    stripeAccountId,
  } = getPurchaseCommonEventParams(state)
  const email = selectEmail(state)
  const config = selectUserConfigData(state)
  const userCookieConsentAnswer = config?.cookieConsent as string[]

  return {
    trialPrice: trialPeriodPrice,
    uuid,
    periodName,
    periodQuantity,
    currency,
    screenName,
    email: userCookieConsentAnswer?.includes(
      CookieConsentOption.FUNCTIONAL_COOKIES,
    )
      ? email
      : '',
    stripeAccountName,
    stripeAccountId,
  }
}
